import React from 'react';
import BaseEChart from './BaseEChart';
import { buildMetricComparisonOption } from './comparisonMetricOptions';
import type { MetricChartPoint } from '@app-types/comparisonMetric';

export interface MetricComparisonBarChartProps {
  points: MetricChartPoint[];
  /** Pixel height passed to BaseEChart (Figma chart content is 142px). */
  height?: number;
  className?: string;
}

/**
 * Vertical bar chart for the Sales / Ordinary Profit / Net Income cards.
 * Actual bars are #e60000, forecast bars are #e49697.
 * Renders through BaseEChart; do not import ReactECharts directly.
 * See kiro_sales_revenue_task.md §7.
 */
const MetricComparisonBarChart: React.FC<MetricComparisonBarChartProps> = ({
  points,
  height = 142,
  className,
}) => (
  <BaseEChart
    option={buildMetricComparisonOption(points)}
    height={height}
    className={className}
    ariaLabel="業績比較チャート"
  />
);

export default MetricComparisonBarChart;
